







































































import Vue from "vue";
import { Data, Methods, Computed, Props, MonthMappedReport } from "./types";
import { PropType } from "vue";
import { ReportHeader } from "../../types";
import "@/components/icons";
import Heading from "@/components/Atoms/Typography/Heading/index.vue";
import Body from "@/components/Atoms/Typography/Body/index.vue";

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "SelectWeekly",
  components: {
    Heading,
    Body
  },
  props: {
    dataArray: {
      type: Array as PropType<Props["dataArray"]>,
      required: true
    }
  },
  data() {
    return {
      defaultYear: new Date().getFullYear(),
      isToggleSideNav: {},
      selectedWeek: {},
      selectedClass: "sideNav__childBlock__header--selected"
    };
  },
  computed: {
    yearsReports() {
      let yearsReports: { [key: number]: MonthMappedReport[] } = {};
      let startYear = 2020;
      const monthMappedReports = MonthMappedReport.makeMonthMappedReports(
        this.dataArray
      );
      const currentYear = new Date().getFullYear();
      while (startYear <= currentYear) {
        yearsReports[startYear] = [];
        monthMappedReports.forEach(report => {
          if (report.year == startYear) {
            yearsReports[startYear].push(report);
          }
        });
        startYear++;
      }

      return yearsReports;
    }
  },
  created() {
    this.$set(this.isToggleSideNav, this.defaultYear, true);
    if (this.dataArray[0].isMonthlyReport()) {
      this.selectedWeek = this.dataArray[1];
    } else {
      this.selectedWeek = this.dataArray[0];
      this.$emit("submit", this.dataArray[0].url);
    }
  },
  methods: {
    toggleSideNav(year: number) {
      this.$set(this.isToggleSideNav, year, !this.isToggleSideNav[year]);
    },
    selectWeekly(data: ReportHeader) {
      this.selectedWeek = data;
      this.$emit("click", data.url);
    }
  }
});
